module.exports = "../static/media/banner.f3cf76c0.png";